import Choices from "choices.js";

$(document).ready(/(\/student-management\/enrolment-tor\/\d+\/course-work\/\d+\/(create|edit))/
    .test(window.location.pathname)&&function() {

    // initialize internal/external lecturers correctly
    $(".element-row").each(function(key, elem) {
        elem = $(elem);
        if (elem.find(".select-external-lecturer").val()) {
            elem.find(".type-selector[value=1]").attr("checked", true);
            elem.find(".select-internal-lecturer").closest('.js-choice')[0].choices.disable();
            elem.find(".select-internal-lecturer").closest('.choices').hide();
        } else {
            elem.find(".type-selector[value=0]").attr("checked", true);
            elem.find(".select-external-lecturer").val("").hide();
        }
    });

    // handle changes in internal/external lecturer when radio boxes are ticked
    $(".element-row-container").on("click", ".type-selector", function(e) {
        const target = $(e.target);
        const row = target.parents(".element-row");
        if (target.val() === "1") { // is external
            row.find(".select-internal-lecturer").closest('.js-choice')[0].choices.disable();
            row.find(".select-internal-lecturer").closest('.choices').hide();
            row.find(".select-external-lecturer").show();
        } else {
            row.find(".select-external-lecturer").val("").hide();
            row.find(".select-internal-lecturer").closest('.js-choice')[0].choices.enable();
            row.find(".select-internal-lecturer").closest('.choices').show();
        }
    });

    // form collection handling for post accredited course works
    if ($('#edit-enrolment-tor-post-accredited-course-work').length) {
        const removalFunction = function () {
            $(this).closest('div.element-row').remove();
        };

        // initialize add row button
        $(".btn-add-row").click(function () {
            const container = $(this).closest("div.card").find(".element-row-container");
            const currentCount = container.find(".element-row").length;
            let template = container.data('template');
            template = template.replace(/__index__/g, currentCount);
            container.append(template);
            container.find(".btn-remove-row:last").click(removalFunction);
            container.find(".element-row:last input[name*=sort]").val(currentCount);
            container.find(".element-row:last .js-choice").each(function () {
                this.choices = new Choices(this, window.choicesConfig(this))
            });
            container.find(".element-row:last input[value=0]").click();
        });

        // initialize remove row button
        $(".element-row-container .btn-remove-row").click(removalFunction);
    }
});
